var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0005,
    cy: 12.6919,
    r: 10.9256,
    stroke: "#FFFEFA",
    strokeWidth: 2.3412
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.442 11.4254C16.8178 11.4254 17.113 11.5462 17.3277 11.7877C17.5514 12.0203 17.6632 12.3648 17.6632 12.821C17.6632 13.2863 17.5514 13.6396 17.3277 13.8812C17.113 14.1228 16.8178 14.2435 16.442 14.2435H9.73214C9.35639 14.2435 9.05668 14.1228 8.83302 13.8812C8.61831 13.6396 8.51095 13.2863 8.51095 12.821C8.51095 12.3648 8.61831 12.0203 8.83302 11.7877C9.05668 11.5462 9.35639 11.4254 9.73214 11.4254H16.442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteLine);
export default __webpack_public_path__ + "static/media/delete_line.ec94a339c498b22c2279ba44648964b1.svg";
export { ForwardRef as ReactComponent };